import React, { useState } from 'react';
import { Div, Span, ColDiv } from 'styles';
import * as S from './InputStyle';

export function Input({
  name,
  value,
  onChange,
  type,
  label,
  subLabel,
  disabled,
  helperText,
  error,
  unit,
  $default,
  $flex,
  ...props
}) {
  const [tempType, setTempType] = useState(type || 'text');

  const handleChange = (e) => {
    const { name, value } = e.target;
    const maxLength = props.maxLength || 0;
    const valueMaxLength = maxLength ? value.substring(0, maxLength) : value;
    const tempValue = type === 'tel' ? valueMaxLength.replaceAll(/\D/g, '') : valueMaxLength;

    onChange(name, tempValue);
  };

  return (
    <ColDiv $flex={$flex}>
      {label && (
        <S.Label $default={$default} $disabled={disabled}>
          {label}
          {subLabel && (
            <Span $marginLeft={8} $color={disabled ? 'disabled' : 'primary700'} $type="m">
              {subLabel}
            </Span>
          )}
        </S.Label>
      )}
      <Div $position="relative">
        <S.InputField
          name={name}
          value={value}
          type={tempType !== 'tel' ? tempType : 'text'}
          onChange={handleChange}
          disabled={disabled}
          aria-invalid={error}
          {...props}
        />
        {unit && <S.Unit $disabled={disabled}>{unit}</S.Unit>}
      </Div>
      {error && <S.HelperText>{helperText}</S.HelperText>}
    </ColDiv>
  );
}

export function TimeInput({ name, value, onChange, error }) {
  const [tempType, setTempType] = useState('tel');

  const handleChange = (e) => {
    const { name, value } = e.target;
    const tempValue = value.replaceAll(/\D/g, '');

    onChange(name, tempValue);
  };

  return (
    <input
      name={name}
      value={value}
      type={tempType}
      onChange={handleChange}
      aria-invalid={error}
      style={{ width: '60px', textAlign: 'center' }}
    />
  );
}
